import styled from "styled-components";

export const NotificationReportWrap = styled.div`


`;